import {Collapse, Grid} from "@mui/material";
import {useCallback, useState} from "react";
import MhdSelect from "../../atomicComponents/MhdSelect";
import {gridChoices, realLabels} from "../../../utils/choices";
import MhdInput from "../../atomicComponents/MhdInput";
import WidgetSwitch from "../../atomicComponents/WidgetSwitch";
import MhdWidgetDivider from "../../atomicComponents/MhdWidgetDivider";
import {setAndUpdate, validateAndUpdate} from "../../../utils/helpers";
import WidgetDivider from "../../atomicComponents/WidgetDivider";
import MhdSwitch from "../../atomicComponents/MhdSwitch";

const ViewWidget = ({data, mods, warn, errs, update, setter, shared}) => {
  const [customVAxis, setCustomVAxis] = useState(false)

  return (
    <Grid container spacing={1}>
      <Grid item xs={12}>
        <MhdSelect
          label="Grid"
          value={data.grid ? data.grid : 'null'}
          onChange={useCallback((v) => setAndUpdate("grid", v, setter, update), [])}
          choices={gridChoices}
        />
      </Grid>
      <Grid item xs={12}>
        <WidgetDivider
            label="COLORBAR"
            value={customVAxis}
            onChange={setCustomVAxis}
        >
          <Collapse in={customVAxis}>
            <Grid container spacing={1} pt={"2px"}>
              <Grid item xs={4}>
                <MhdInput
                  label="Ticks"
                  value={data.zaxis_ticks}
                  override={mods.zaxis_ticks}
                  warning={warn.zaxis_ticks}
                  error={errs.zaxis_ticks}
                  onChange={useCallback((v) => validateAndUpdate("zaxis_ticks", v, setter, update), [])}
                />
              </Grid>
              <Grid item xs={4}>
                <Collapse in={!data.symmetric}>
                  <MhdInput
                    label="Min"
                    value={data.zaxis_min}
                    override={mods.zaxis_min}
                    warning={warn.zaxis_min}
                    error={errs.zaxis_min}
                    onChange={useCallback((v) => validateAndUpdate("zaxis_min", v, setter, update), [])}
                  />
                </Collapse>
              </Grid>
              <Grid item xs={4}>
                <Collapse in={!data.symmetric}>
                  <MhdInput
                    label="Max"
                    value={data.zaxis_max}
                    override={mods.zaxis_max}
                    warning={warn.zaxis_max}
                    error={errs.zaxis_max}
                    onChange={useCallback((v) => validateAndUpdate("zaxis_max", v, setter, update), [])}
                  />
                </Collapse>
              </Grid>
              <Grid item xs={4}>
                <MhdSwitch
                  label="Symmetric"
                  value={data.symmetric}
                  override={mods.symmetric}
                  warning={warn.symmetric}
                  error={errs.symmetric}
                  onChange={useCallback((v) => setAndUpdate("symmetric", v, setter, update), [])}
                />
              </Grid>
              <Grid item xs={8}>
                <Collapse in={mods.symmetric !== undefined ? mods.symmetric : data.symmetric}>
                  <MhdInput
                    label="Value"
                    value={data.symmetric_value}
                    override={mods.symmetric_value}
                    warning={warn.symmetric_value}
                    error={errs.symmetric_value}
                    onChange={useCallback((v) => validateAndUpdate("symmetric_value", v, setter, update), [])}
                  />
                </Collapse>
              </Grid>
            </Grid>
          </Collapse>
        </WidgetDivider>
      </Grid>
    </Grid>
  );
}
export default ViewWidget;